export const API_VERSION =
  process.env.NEXT_PUBLIC_STRIPE_VERSION ||
  process.env.REACT_APP_STRIPE_VERSION;
